import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { VersionListContentContainer } from "~/components/AssetModal/AssetModalFooter/VersionList/VersionListContent/components/VersionListContentContainer";
import { VersionListContentHeader } from "~/components/AssetModal/AssetModalFooter/VersionList/VersionListContent/components/VersionListContentHeader";
import { VersionsListContainer } from "~/components/AssetModal/AssetModalFooter/VersionList/VersionListContent/components/VersionsListContainer";
import { PublicVersionListItem } from "~/components/AssetModal/AssetModalFooter/VersionList/VersionListContent/VersionListItem/PublicVersionListItem";
import { usePublicVersionsList } from "~/swr-hooks/versions/usePublicVersionsList";
export const PublicVersionsListContent = /*#__PURE__*/ memo(()=>{
    var _versionsData_data;
    const { data: versionsData } = usePublicVersionsList();
    const versions = useMemo(()=>{
        var _versionsData_data;
        var _versionsData_data_clips;
        return (_versionsData_data_clips = versionsData === null || versionsData === void 0 ? void 0 : (_versionsData_data = versionsData.data) === null || _versionsData_data === void 0 ? void 0 : _versionsData_data.clips) !== null && _versionsData_data_clips !== void 0 ? _versionsData_data_clips : [];
    }, [
        versionsData === null || versionsData === void 0 ? void 0 : (_versionsData_data = versionsData.data) === null || _versionsData_data === void 0 ? void 0 : _versionsData_data.clips
    ]);
    return /*#__PURE__*/ _jsx(VersionListContentContainer, {
        children: !!versions.length && /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(VersionListContentHeader, {
                    hasOtherVersions: versions.length > 1
                }),
                /*#__PURE__*/ _jsx(VersionsListContainer, {
                    children: versions.map((version)=>/*#__PURE__*/ _jsx(PublicVersionListItem, {
                            version: version
                        }, version.id))
                })
            ]
        })
    });
});
PublicVersionsListContent.displayName = "PublicVersionsListContent";
